import FormData from 'form-data';
import { apiCall } from '.';

export const completeBorrowerProfileApi = (payload: FormData, headers: {}) => {
  return apiCall(true).post('/borrowers', payload, { headers });
};

export const fetchBorrowerProfileApi = () => {
  return apiCall(true).get('/borrowers');
};

export const updateBorrowerProfile = (payload: FormData, headers: {}) => {
  return apiCall(true).put('/borrowers', payload, { headers });
};

export const deleteWorkDocumentApi = () => {
  return apiCall(true).delete('/borrowers/work-document');
};

export const deleteIncomeDocumentApi = () => {
  return apiCall(true).delete('/borrowers/income-document');
};
